/* eslint-disable import/prefer-default-export */
import rtlDetect from 'rtl-detect';
import { createIntl, createIntlCache } from 'react-intl';

import { SET_LOCALE_SUCCESS } from '../constants';

// Cache for intl instances - improves performance
const intlCache = createIntlCache();

export function getIntlFromState(state) {
  const intlState = (state && state.intl) || {};
  const { locale = 'en-US', messages = {} } = intlState;
  const localeMessages = messages[locale] || {};

  // Create intl instance using the new API (react-intl v3+)
  const intl = createIntl(
    {
      locale,
      messages: localeMessages,
      defaultLocale: 'en-US',
    },
    intlCache
  );

  return intl;
}

export const getIntl = () => (dispatch, getState) => getIntlFromState(getState());

export const setLocale = ({ locale, messages }) => async (dispatch, getState) => {
  dispatch({
    type: SET_LOCALE_SUCCESS,
    payload: {
      locale,
      langDir: rtlDetect.getLangDir(locale),
      messages,
    },
  });
  return getIntlFromState(getState());
};
